(function () {
  function imageFromPairs(pairA, pairB) {
    if (pairA === 1 && pairB === 4) return 1;
    if (pairA === 2 && pairB === 4) return 2;
    if (pairA === 1 && pairB === 3) return 3;
    return 4;
  }

  function init(scope) {
    var section = scope.classList && scope.classList.contains('lf-lighting')
      ? scope
      : scope.querySelector('.lf-lighting');

    if (!section || section.dataset.lfLighting) return;
    section.dataset.lfLighting = 'true';

    var buttons = {
      1: section.querySelector('.button_1'),
      2: section.querySelector('.button_2'),
      3: section.querySelector('.button_3'),
      4: section.querySelector('.button_4')
    };

    if (!buttons[1] || !buttons[2] || !buttons[3] || !buttons[4]) return;

    var pairA = buttons[1].classList.contains('is-active') ? 1 : 2;
    var pairB = buttons[4].classList.contains('is-active') ? 4 : 3;

    function render() {
      var key = imageFromPairs(pairA, pairB);

      section.querySelectorAll('.lighting-img-container img').forEach(function (img) {
        img.classList.toggle('is-visible', img.classList.contains('show_' + key));
      });

      section.querySelectorAll('.lighting-stat').forEach(function (stat) {
        stat.classList.toggle('is-visible', stat.classList.contains('lighting-stat-' + key));
      });

      buttons[1].classList.toggle('is-active', pairA === 1);
      buttons[2].classList.toggle('is-active', pairA === 2);
      buttons[3].classList.toggle('is-active', pairB === 3);
      buttons[4].classList.toggle('is-active', pairB === 4);
    }

    buttons[1].addEventListener('click', function () {
      pairA = 1;
      render();
    });
    buttons[2].addEventListener('click', function () {
      pairA = 2;
      render();
    });
    buttons[3].addEventListener('click', function () {
      pairB = 3;
      render();
    });
    buttons[4].addEventListener('click', function () {
      pairB = 4;
      render();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('.lf-lighting').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
